<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header"><span>代理商列表</span></div>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="userId" label="用户ID" width="90" />
        <el-table-column prop="agentName" label="名称" min-width="140" />
        <el-table-column prop="promoCode" label="推广码" width="120" />
        <el-table-column prop="totalCommission" label="累计佣金" width="110" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.status === 1 ? 'success' : row.status === 2 ? 'danger' : row.status === 3 ? 'info' : 'warning'">
              {{ labelOf(AGENT_STATUS, row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" min-width="120">
          <template slot-scope="{ row }">{{ formatUserDate(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openEditDialog(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
      />
    </el-card>

    <el-dialog title="编辑代理商" :visible.sync="editVisible" width="460px">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="80px">
        <el-form-item label="名称" prop="agentName">
          <el-input v-model="editForm.agentName" />
        </el-form-item>
        <el-form-item label="推广码" prop="promoCode">
          <el-input v-model="editForm.promoCode" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="editForm.status" style="width: 100%">
            <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitEdit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAgents, updateAgent } from '@/api/admin'
import { AGENT_STATUS, labelOf, optionsOf } from '@/utils/adminConstants'
import { formatUserDate } from '@/utils/userFormat'
import listPage from '@/mixins/listPage'

export default {
  name: 'AgentsList',
  mixins: [listPage],
  data() {
    return {
      AGENT_STATUS,
      editVisible: false,
      submitting: false,
      editForm: { id: null, agentName: '', promoCode: '', status: 1 },
      editRules: {
        agentName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        promoCode: [{ required: true, message: '请输入推广码', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  computed: {
    statusOptions() {
      return optionsOf(AGENT_STATUS)
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    labelOf,
    formatUserDate,
    fetchList(params) {
      return getAgents({ ...params, status: 1 })
    },
    openEditDialog(row) {
      this.editForm = {
        id: row.id,
        agentName: row.agentName,
        promoCode: row.promoCode,
        status: row.status
      }
      this.editVisible = true
    },
    submitEdit() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await updateAgent(this.editForm.id, this.editForm)
          this.$message.success('保存成功')
          this.editVisible = false
          this.loadList()
        } catch (e) {
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
